/* eslint-disable test-selectors/button */
import React from "react";
import Modal from "react-responsive-modal";
import { Button } from "@revvsales/components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// import formModeImage from "../../assets/send-anyway-popup.png";
import UNFILLED_FORM_FILLED from "../../assets/unfilled-form-filled.gif";

const SendConfirmationPopup = ({
  togglePopUp,
  updateMultipleState,
  buttonValue,
  editDocument,
  docId,
  stripePaymentDetails,
  buttonData,
  docStage,
  fieldsUsed,
}) => {
  const fillerUnassignedValue = [];
  const fillerAssignedRecipentValue = [];
  fieldsUsed.forEach(element => {
    if (element.value && element.value.length !== 0)
      fillerUnassignedValue.push(element);
    if (element.filler_type === "RECIPIENT") {
      fillerAssignedRecipentValue.push(element);
    }
  });
  const _getHeaderText = () => {
    switch (buttonValue) {
      case "eSign":
        return (
          <span>
            <FontAwesomeIcon
              className="emptysigner-popup-exclamation-icon"
              icon={["fas", "exclamation-triangle"]}
            />
            {`You have ${fieldsUsed.length -
              fillerUnassignedValue.length} unfilled form fields`}
          </span>
        );

      case "forAcceptance":
        return (
          <span>
            <FontAwesomeIcon
              className="emptysigner-popup-exclamation-icon"
              icon={["fas", "exclamation-triangle"]}
            />
            You have some unfilled form fields
          </span>
        );
      case "forReviewer":
        return (
          <span>
            <FontAwesomeIcon
              className="emptysigner-popup-exclamation-icon"
              icon={["fas", "exclamation-triangle"]}
            />
            You have some unfilled form fields
          </span>
        );

      default:
        return (
          <span>
            <FontAwesomeIcon
              className="emptysigner-popup-exclamation-icon"
              icon={["fas", "exclamation-triangle"]}
            />
            You have some unfilled form fields
          </span>
        );
    }
  };

  // const _getSubHeaderText = () => {
  //   switch (buttonValue) {
  //     case "eSign":
  //       return "";

  //     case "forAcceptance":
  //       return "";

  //     case "forReviewer":
  //       return "";

  //     default:
  //       return "";
  //   }
  // };

  const _getDetailsComponent = () => {
    switch (buttonValue) {
      case "eSign":
        return (
          <div
            style={{
              marginTop: "10px",
            }}>
            <div className="send-confirmation-body-list-item">
              <div className="send-confirmation-body-dot">&#8226;</div>
              <div className="send-confirmation-list-info">
                If you missed filling them, go <strong>back to document</strong>{" "}
                to fill them out. <br /> OR
              </div>
            </div>

            <div className="send-confirmation-body-list-item">
              <div className="send-confirmation-body-dot">&#8226;</div>
              <div className="send-confirmation-list-info">
                If you left them out on purpose or want your recipients to fill
                them, continue to <strong>send anyway</strong>. Give fill and
                sign access to recipients in the next step.
              </div>
            </div>
          </div>
        );

      case "forAcceptance":
        return (
          <div
            style={{
              marginTop: "10px",
            }}>
            <div className="send-confirmation-body-list-item">
              <div className="send-confirmation-body-dot">&#8226;</div>
              <div className="send-confirmation-list-info">
                You can <strong>Review and fill</strong> them yourself or,
              </div>
            </div>
            <div className="send-confirmation-body-list-item">
              <div className="send-confirmation-body-dot">&#8226;</div>
              <div className="send-confirmation-list-info">
                <strong>Continue anyway</strong> to add recipient details and
                send document for acceptance.
              </div>
            </div>
          </div>
        );

      case "forReviewer":
        return (
          <div
            style={{
              marginTop: "10px",
            }}>
            <div className="send-confirmation-body-list-item">
              <div className="send-confirmation-body-dot">&#8226;</div>
              <div className="send-confirmation-list-info">
                You can <strong>Review and fill</strong> them yourself or,
              </div>
            </div>
            <div className="send-confirmation-body-list-item">
              <div className="send-confirmation-body-dot">&#8226;</div>
              <div className="send-confirmation-list-info">
                <strong>Continue anyway</strong> to add recipient details and
                share document with them.
              </div>
            </div>
          </div>
        );

      default:
        return (
          <div
            style={{
              marginTop: "10px",
            }}>
            <div className="send-confirmation-body-list-item">
              <div className="send-confirmation-body-dot">&#8226;</div>
              <div className="send-confirmation-list-info">
                Review and fill rest
              </div>
            </div>
            <div className="send-confirmation-body-list-item">
              <div className="send-confirmation-body-dot">&#8226;</div>
              <div className="send-confirmation-list-info">
                Choose to send as it is, or
              </div>
            </div>
            <div className="send-confirmation-body-list-item">
              <div className="send-confirmation-body-dot">&#8226;</div>
              <div className="send-confirmation-list-info">
                Send anyway and let the recipients fill the form fields.
              </div>
            </div>
          </div>
        );
    }
  };
  const _getSubHeaderComponent = () => {
    let headerValue = "This document contains unfilled form fields.";
    if (buttonValue === "eSign") {
      headerValue = `You have assigned ${fillerAssignedRecipentValue.length}/${
        fieldsUsed.length
      } fields to recipients and left  ${fieldsUsed.length -
        fillerUnassignedValue.length}/ ${fieldsUsed.length} empty.`;
    }
    return headerValue;
  };
  const _getBackButtonText = () => {
    switch (buttonValue) {
      case "eSign":
        return "Back to document";

      case "forAcceptance":
        return "Review and fill";

      case "forReviewer":
        return "Review and fill";

      default:
        return "Review and fill";
    }
  };

  const _getSendButtonText = () => {
    switch (buttonValue) {
      case "eSign":
        return "Send anyway";

      case "forAcceptance":
        return "Continue anyway";

      case "forReviewer":
        return "Continue anyway";

      default:
        return "Continue anyway";
    }
  };

  return (
    <Modal
      classNames={{
        modal: "sendconfirmationmodal",
      }}
      open
      onClose={() => {
        updateMultipleState({
          showSendConfirmationPopup: false,
        });
      }}
      center
      closeOnOverlayClick={false}>
      <div className="send-confirmation-popup-wrapper">
        <div className="send-confirmation-body">
          <div className="send-confirmation-header">{_getHeaderText()}</div>
          <div className="send-confirmation-body-wrapper">
            <div className="send-confirmation-body-info">
              {_getSubHeaderComponent()}
              {_getDetailsComponent()}
            </div>
            <div className="send-confirmation-body-image-wrapper">
              <img
                src={UNFILLED_FORM_FILLED}
                alt="form-mode-check"
                className="send-confirmation-body-image"
              />
            </div>
          </div>
        </div>
        <div className="send-confirmation-footer">
          <Button
            className="send-confirmation-btn-inherit"
            data-test="review-and-fill-button"
            onClick={() => {
              if (docStage !== "DRAFT") {
                editDocument(docId);
              }
              updateMultipleState({
                showSendConfirmationPopup: false,
              });
            }}
            onKeyPress={() => {}}>
            {_getBackButtonText()}
          </Button>
          <Button
            className="revv-btn-primary"
            data-test="continue-anyway-button"
            onClick={() => {
              if (buttonValue === "forReviewer") {
                if (
                  buttonData.length &&
                  ((stripePaymentDetails && !stripePaymentDetails.is_active) ||
                    !stripePaymentDetails)
                ) {
                  // if there is a disabled button in the doc
                  updateMultipleState({
                    showSendConfirmationPopup: false,
                    stripeButtonRemovePopup: true,
                  });
                } else {
                  updateMultipleState({
                    showSendConfirmationPopup: false,
                    showAddRecipientsPopup: true,
                  });
                }
              }
              // else if (buttonValue === "forAcceptance") {
              //   updateMultipleState({
              //     showSendConfirmationPopup: false,
              //     addAcceptorList: true,
              //   });
              // } else if (buttonValue === "eSign") {
              //   updateMultipleState({
              //     showSendConfirmationPopup: false,
              //     showSignerListPopup: true,
              //   });
              // }
              else {
                togglePopUp("showFormModeSendAnyway", true, buttonValue);
                updateMultipleState({
                  showSendConfirmationPopup: false,
                });
              }
            }}
            onKeyPress={() => {}}>
            {_getSendButtonText()}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default SendConfirmationPopup;



// WEBPACK FOOTER //
// ./src/components/DocumentApprovalPopupNew/SendConfirmationPopup.js